module.exports = __webpack_public_path__ + "static/media/warning.3377f425.svg";